import { safeNumericString } from 'app/infrastructure/data/sanitize';
import { deepEquals } from 'app/infrastructure/js';
import { DefaultContainerProps } from 'app/infrastructure/redux';
import { DashboardAdminState } from '../types-store';

export interface DashboardSavedReportsSelectorProps {
  id: number;
  searchFavouriteId: number;
  shouldPrompt: boolean;
}

type DashboardFormSelectors = { [T in keyof DashboardSavedReportsSelectorProps]?:
  (state: DashboardAdminState, props: DefaultContainerProps) => DashboardSavedReportsSelectorProps[T] };

export const selectors: DashboardFormSelectors = {
  id: (_, { params }) =>
    safeNumericString(params?.id) || undefined,
  searchFavouriteId: (_, { router }) =>
    safeNumericString(router?.location?.query?.favouriteId) || undefined,
  shouldPrompt: ({ savedReports: { savedReports, originalSavedReports } }) =>
    !deepEquals(savedReports, originalSavedReports)
};
